var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked 1",
    clipPath: "url(#clip0_233_1059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72 36C72 55.882 55.882 72 36 72C16.1181 72 4.57764e-05 55.882 4.57764e-05 36C4.57764e-05 16.118 16.1181 0 36 0C55.882 0 72 16.118 72 36Z",
    fill: "#FF831A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF4\x80\x85\x8E",
    d: "M36.0149 41.6869C35.2921 41.6869 34.7327 41.4893 34.3367 41.0941C33.9505 40.6989 33.7476 40.1485 33.7278 39.4428L33.4456 25.9357C33.4456 25.8416 33.4406 25.7522 33.4307 25.6675C33.4307 25.5734 33.4307 25.4935 33.4307 25.4276C33.4307 24.6749 33.6684 24.0821 34.1436 23.6492C34.6189 23.2164 35.2426 23 36.0149 23C36.7971 23 37.4208 23.2164 37.8862 23.6492C38.3515 24.0821 38.5842 24.6749 38.5842 25.4276C38.5842 25.4935 38.5842 25.5734 38.5842 25.6675C38.5842 25.7522 38.5793 25.8416 38.5694 25.9357L38.3169 39.4428C38.2971 40.1485 38.0892 40.6989 37.6931 41.0941C37.2971 41.4893 36.7377 41.6869 36.0149 41.6869ZM36.0149 50C35.4604 50 34.9555 49.8777 34.5 49.633C34.0446 49.3884 33.6783 49.0544 33.401 48.6309C33.1337 48.2169 33 47.7559 33 47.2478C33 46.7397 33.1337 46.2786 33.401 45.8646C33.6783 45.4506 34.0446 45.1213 34.5 44.8766C34.9555 44.632 35.4604 44.5097 36.0149 44.5097C36.5595 44.5097 37.0595 44.632 37.5149 44.8766C37.9703 45.1213 38.3317 45.4506 38.5991 45.8646C38.8664 46.2786 39 46.7397 39 47.2478C39 47.7559 38.8664 48.2169 38.5991 48.6309C38.3317 49.0544 37.9703 49.3884 37.5149 49.633C37.0595 49.8777 36.5595 50 36.0149 50Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_1059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.0d1ac69ef54d3cf7aff234d27ba0d3e6.svg";
export { ForwardRef as ReactComponent };